import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import { toast, ToastContainer, Zoom } from "react-toastify";
import userService from "../../app/services/user.service";
import Card from "../../UI/Card/Card";
import Graybg from "../../UI/Graybg";
import Input from "../../UI/Input/Input";
import Loader from "../../UI/loader/loader";
import Modals from "../../UI/Modals/Modals";
import SecBTN from "../../UI/SecBTN";
import Select from "../../UI/Select/Select";
import SmallLoader from "../../UI/SmallLoader/SmallLoader";
import DataTable from "./DataTable/Table";
import Toast from "../../UI/Toast/Toast";

const EditTopic = () => {
  const x = JSON.parse(localStorage.getItem("user"));
  const [showPopUp, setShowPopUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [noData, setNoData] = useState(false);
  const [subjectList, setSubjectList] = useState([])
  const [topicList, setTopicList] = useState([])
  const [selectedSubject, setSelectedSubject] = useState('')
  const [addModalData, setAddModalData] = useState({
    topic_name: "",
    sub_id: "",
    user_id: '',
    topic_sequence: '',
    status: 1,
  });
  
  const [selectedStatus, setSelectedStatus] = useState('');
  useEffect(() => {
    setLoading(true)
    userService.getSubjectList()
      .then((data) => {
        setSubjectList(data.data.data);
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false)
        console.log(err);
        toast.error("Something Went Wrong !!")
      })
  }, []);
  const selectSubHandler = (e) => {
    setSelectedSubject(e.target.value);
  };
  const reloadDataFn = () => {
    setTimeout(() => {
      userService.getTopicListBySid(selectedSubject)
        .then((data) => {
          const datas = data.data.data.map((item, i) => {
            return { index: i + 1, ...item }
          })
          setTopicList(datas);
          console.log("topic list data after update", datas);
        })
        .catch((err) => {
          console.log(err.response.data.info);
          if (err.response.data.info) {
            setTopicList([])
            toast.error(err.response.data.message)
          }
        })
    }, 500);
  }
  const searchHandler = () => {
    if (!selectedSubject) {
      toast.error("Please select a subject");
      return;
    }
  
    setLoading(true);
    setNoData(true);
  
    userService
      .getTopicListBySid(selectedSubject)
      .then((data) => {
        let datas = data.data.data.map((item, i) => ({
          index: i + 1,
          ...item,
        }));
  
        // Filter by status if selected
        if (selectedStatus !== "") {
          datas = datas.filter(
            (item) => String(item.status) === String(selectedStatus)
          );
        }
  
        setTopicList(datas);
      })
      .catch((err) => {
        console.log(err);
        setTopicList([]);
        toast.error("Something Went Wrong !!");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const activationHandler = (status, topicId) => {
    setLoading(true)
    let body;
    let msg;
    if (status == 1) {
      body = {
        "topicid": topicId,
        "status": 0
      };
      msg = "Topic Deactivated Successfully."
    } else {
      body = {
        "topicid": topicId,
        "status": 1
      };
      msg = "Topic Activated Successfully.";
    }
    userService.updateTopicStatus(body)
      .then((data) => {
        console.log(data);
        toast.success(msg)
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false)
        console.log(err);
        toast.error("Something Went Wrong !!")
      })
    // 
    reloadDataFn();
  };
  const updateHandler = (data) => {
    console.log("Ok Response")
    const body = {
      topic_id: data.topic_id,
      topic_name: data.topic_name,
      sub_id: +selectedSubject,
      user_id: +x?.data?.user?.user_id,
      topic_sequence: +data.topic_sequence !== 0 ? +data.topic_sequence : null,
      status: data.status,
    };
    userService.updateTopic(body)
      .then((data) => {
        console.log(data);
        toast.success("Topic Updated Successfully", data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something Went Wrong !!")
      });
    reloadDataFn();
  }
  const addTopicPopup = () => {
    setShowPopUp(true)
  };
  const hideHandler = () => {
    setShowPopUp(false)
  };
  const onAddTopic = () => {
    setBtnLoading(true)
    const body = {
      topic_name: addModalData.topic_name,
      sub_id: +addModalData.sub_id,
      user_id: x?.data?.user_id,
      topic_sequence: +addModalData.topic_sequence,
      status: 1,
    };
    userService.createTopic(body)
      .then((data) => {
        console.log(data);
        toast.success("Topic Added Successfully.")
        setBtnLoading(false)
        setShowPopUp(false)
        setAddModalData({
          topic_name: "",
          sub_id: "",
          user_id: '',
          topic_sequence: '',
          status: 1,
        })
      })
      .catch((err) => {
        setBtnLoading(false)
        console.log(err);
        toast.error("Something Went Wrong !!")
      });
    reloadDataFn();
  };
  const btnCondition = (addModalData.sub_id == null || "") || (addModalData.topic_name.length == 0) || (addModalData.topic_sequence.length == 0);
  return (
    <div className="section">
      {loading && <Loader />}
      <Modals show={showPopUp} onHide={hideHandler}>
        <Row className="g-3">
          <Col sm={12}>
            <Form.Label>Subject</Form.Label>
            <Select value={addModalData.sub_id} onChange={e => setAddModalData(prev => {
              return {
                ...prev,
                "sub_id": e.target.value
              }
            })}
            >
              <option value="" disabled>
                Select Subject
              </option>
              {subjectList.map((data) => {
                return <option value={data.sub_id}>{data.sub_name}</option>;
              })}
            </Select>
          </Col>
          <Col sm={12}>
            <Form.Label>Topic Name :</Form.Label>
            <Input type="text" placeholder="Enter Topic Name" value={addModalData.topic_name} onChange={e => setAddModalData(prev => {
              return {
                ...prev,
                "topic_name": e.target.value
              }
            })}
            />
          </Col>
          <Col sm={12}>
            <Form.Label>Topic Sequence :</Form.Label>
            <Input type="number" placeholder="Enter Topic Sequence" value={addModalData.topic_sequence} onChange={e => setAddModalData(prev => {
              return {
                ...prev,
                "topic_sequence": e.target.value
              }
            })} />
          </Col>
        </Row>
        <div className="text-center mt-5 mb-3">
          <SecBTN className={btnCondition ? "sec-btn1-deactive " : "sec-btn1"} disabled={btnCondition} onClick={onAddTopic}>
            Add Topic {btnLoading && <SmallLoader />}
          </SecBTN>
        </div>
      </Modals>
      <Toast />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Edit Topic</h4>
          <Breadcrumb>
            {/*<Breadcrumb.Item><Link to='/'> Home </Link></Breadcrumb.Item>*/}
            <Breadcrumb.Item active>Edit Topic</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <SecBTN className="sec-btn" onClick={addTopicPopup}>
          Add Topic
        </SecBTN>
      </div>
      <Graybg>
        <Card className="mb-4">
          <Row className="align-items-end">
            <Col md={5}>
              <Form.Label>Subject :</Form.Label>
              <Select
                value={selectedSubject}
                onChange={selectSubHandler}
              >
                <option disabled value="">
                  Select Subject
                </option>
                {subjectList.map((data) => (
                  <option key={data.sub_id} value={data.sub_id}>
                    {data.sub_name}
                  </option>
                ))}
              </Select>
            </Col>

            <Col md={4}>
              <Form.Label>Status :</Form.Label>
              <Select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Select>
            </Col>

            <Col md={3}>
              <SecBTN
                className="sec-btn w-100 mb-2"
                onClick={searchHandler}
              >
                Search
              </SecBTN>
            </Col>
          </Row>
        </Card>
        <DataTable
          data={topicList}
          noDataShow={noData}
          updateHandler={updateHandler}
          activationHandler={activationHandler}
        />
      </Graybg>
    </div>
  );
};

export default EditTopic;
